import React from 'react'
import { Container, Divider, Typography } from '@cleartrip/ct-design-components'
import { CloseIcon } from '@/assets'
import Swap from '@/assets/icons/Swap'
import { QueryParamsData } from '@/types/srp'
import { isEmpty, pluralize } from '@/utils/general/browserHelper'
import { getFormattedDate } from '@/utils/general/date'
import { ONEWAY_LABEL, ROUND_TRIP_LABEL } from '@/constants/Srp'

interface FlightDetailsHeaderProps {
    searchQuery: Partial<QueryParamsData>
    closeFlightDetails: () => void
    isTripDetails: boolean
}

const FlightDetailsHeader = ({ searchQuery = {}, closeFlightDetails, isTripDetails = false }: FlightDetailsHeaderProps) => {
    const isIntl = searchQuery?.intl === 'y'
    const isRoundTrip = !isEmpty(searchQuery?.return_date)
    const tripTypeLabel = !isRoundTrip ? ONEWAY_LABEL : (isIntl && !isTripDetails ? '' : ROUND_TRIP_LABEL)
    const showSwap = isRoundTrip && (!isIntl || isTripDetails)
    
    const travellerCount =
        (Number(searchQuery?.adults) || 0) + (Number(searchQuery?.childs) || 0) + (Number(searchQuery?.infants) || 0)
    const travellersTxt = pluralize(travellerCount, 'Traveller', 's')
    const departDate = getFormattedDate(searchQuery.depart_date, 'ddd, MMM DD', 'DD/MM/YYYY')
    const returnDate = getFormattedDate(searchQuery.return_date, 'ddd, MMM DD', 'DD/MM/YYYY')
    const source = (searchQuery?.origin && searchQuery?.origin.split(',')?.[0]?.split('- ')?.[1]) || ''
    const destination = (searchQuery?.destination && searchQuery?.destination.split(',')?.[0]?.split('- ')?.[1]) || ''

    return (
        <>
            <Container className="pt-6 pl-6 pb-4">
                <Container onClick={closeFlightDetails}>
                    <CloseIcon className="c-pointer" />
                </Container>
                <Container className="flex flex-middle mt-4">
                    <Typography variant="HM1" className="mr-1">
                        {source}
                    </Typography>
                    {showSwap ? (
                        <Swap height={28} width={28} color="#1A1A1A" />
                    ) : (
                        <Typography variant="HM1">→</Typography>
                    )}
                    <Typography variant="HM1" className="ml-1">
                        {destination}
                    </Typography>
                </Container>
                <Typography variant="B2" className="mt-1" color="subheading">
                    {`${tripTypeLabel} ${isEmpty(tripTypeLabel) ? '' : '・'} ${searchQuery.class}・${travellersTxt}・${departDate}${
                        isRoundTrip ? ` - ${returnDate}` : ''
                    }`}
                </Typography>
            </Container>
            <Divider borderStyle="solid" borderColor="#E6E6E6" />
        </>
    )
}

export default FlightDetailsHeader
